import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getProvincias, deleteProvincia } from "../../../../api/provincia";
import {
  Button,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { getPaises } from "../../../../api/pais";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: () => null,
};

function getData(provincias, paises) {
  let data = [];
  for (let i = 0; i < provincias.length; ++i) {
    const elem = {};
    elem.name = provincias[i].fullName;
    elem.pais = provincias[i].pais
      ? paises.find((cat) => cat._id === provincias[i].pais)?.name
      : "---";
    elem.createdAt = provincias[i].createdAt;
    elem.id = provincias[i]._id;
    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {
  pais: [],
};

export default function ProvinciasPage() {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [data, setData] = useState([]);
  const [provinciaId, setProvinciaId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [paises, setPaises] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();

  function buttonFormatter(cell) {
    let deleteButton;
    if (user?.role === "admin")
      deleteButton = (
        <Tooltip title="Eliminar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setProvinciaId(cell);
              setOpenConfirmDialog(true);
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      );

    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-provincia/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {deleteButton}
      </>
    );
  }

  const columns = [
    { dataField: "name", text: "Provincia", sort: true },
    { dataField: "pais", text: "Pais", sort: true },
    {
      dataField: "createdAt",
      text: "Fecha de creación",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
      searchable: false,
      headerStyle: () => {
        return { width: "110px", textAlign: "center" };
      }
    },
  ];

  useEffect(() => {
    getPaises()
      .then((resp) => {
        if (resp.status === 200) {
          setPaises(resp.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las paises.",
        });
      });
    getProvincias()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las provincias.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Provincias list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-provincia")}
            >
              Añadir nueva
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            search={true}
            data={getData(filteredData, paises)}
            columns={columns}
            />

          <ConfirmDialog
            title={"¿Estás seguro de que quieres eliminar esta provincia?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteProvincia(provinciaId)
                .then((res) => {
                  if (res.status === 204) {
                    alertSuccess({
                      title: "¡Eliminada!",
                      customMessage: "Provincia eliminada correctamente.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la provincia.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
